<template>
  <div class="main">
    <!-- 面板 -->
    <div class="panel">
      <img
        class="title-img"
        src="@/assets/images/service/统计报表-小标题@2x.png"
        alt=""
      />
      <div class="content">
        <div class="content-item">
          <div class="content-item-control">
            <div
              class="control-item"
              v-for="item in controls"
              :key="item"
              :class="{ active: currentControl === item }"
              @click="changeControl(item)"
            >
              {{ item }}
            </div>
          </div>
          <div class="content-item-date">
            <div class="label">开始</div>
            <date-picker
              ref="pickerStime"
              @callback="callbackStart"
              :delayTime="1440"
              :interval="5"
              :initChangeFlag="false"
              :dateEnable="dateEnable"
              :hourEnable="hourEnable"
              :minuteEnable="minuteEnable"
            ></date-picker>
          </div>
          <div class="content-item-date">
            <div class="label">截止</div>
            <date-picker
              ref="pickerEtime"
              @callback="callbackEnd"
              :interval="5"
              :dateEnable="dateEnable"
              :hourEnable="hourEnable"
              :initChangeFlag="false"
              :minuteEnable="minuteEnable"
            ></date-picker>
          </div>
        </div>
        <div class="content-item">
          <div class="content-item-title">要素</div>
          <el-radio-group v-model="checkELe" @change="hanldChange">
            <el-radio
              :label="item.value"
              v-for="item in Eles"
              :key="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
        <div class="btn">
          <el-button type="primary" @click="queryData" :loading="loading"
            >统计</el-button
          >
        </div>
      </div>
    </div>
    <!-- 报表内容展示区域 -->
    <div class="report-content" v-loading="loading">
      <div class="content" v-if="cont">
        <div class="title">
          {{ checkELe === "rain" ? "雨量统计报表" : "极大风统计报表" }}
        </div>
        <div class="desc">
          <p>
            {{ cont }}
          </p>
        </div>
        <div class="image">
          <img :src="'data:image/jpg;base64,' + imgUrl" alt="" />
        </div>
        <div class="sub-title">
          {{ checkELe === "rain" ? "雨量明细表" : "最大风明细表" }}
        </div>
        <div class="table">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>站名</th>
                <th>
                  {{ checkELe === "rain" ? "累积降水(mm)" : "最大风(m/s)" }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="item.objname">
                <td class="xuhao">{{ index + 1 }}</td>
                <td>{{ item.objname }}</td>
                <td>{{ checkELe === "rain" ? item.rain : item.winds }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="no-data" v-else>当前无统计数据</div>
    </div>
  </div>
</template>

<script>
import { apiData } from "@/api";
import DatePicker from "../../plugins/DatePicker/DatePicker.vue";
export default {
  name: "LiveData",
  data() {
    // 辅助函数：获取对齐到指定间隔分钟数的时间字符串
    // interval: 分钟间隔，默认为 5
    const getAlignedTime = (momentObj, interval = 5) => {
      const minutes = momentObj.minute();
      const remainder = minutes % interval;
      // 向下取整到最近的 interval 倍数
      const alignedMoment = momentObj
        .clone()
        .subtract(remainder, "minutes")
        .seconds(0)
        .milliseconds(0);
      return alignedMoment.format("YYYY-MM-DD HH:mm");
    };

    const now = this.$moment();
    const endTimeStr = getAlignedTime(now, 5);

    const startTimeStr = getAlignedTime(now.clone().subtract(1, "day"), 5);
    return {
      controls: ["1小时", "3小时", "6小时", "24小时", "自定义"],
      currentControl: "24小时",
      startTime: startTimeStr,
      endTime: endTimeStr,
      checkELe: "rain",
      Eles: [
        {
          value: "rain",
          label: "降雨",
        },
        {
          value: "wind",
          label: "风力",
        },
      ],
      cont: "",
      imgUrl: "",
      tableData: [],
      loading: false,
      dateEnable: false,
      hourEnable: false,
      minuteEnable: false,
      timeIntervals: {
        "1小时": 1,
        "3小时": 3,
        "6小时": 6,
        "24小时": 24,
      },
    };
  },
  methods: {
    async queryData() {
      this.loading = true;
      const company = this.$route.params.company;
      console.log("company", company);

      const { unit } = JSON.parse(localStorage.getItem(company));
      try {
        const res = await apiData.searchRainConent(
          this.checkELe,
          unit.id,
          this.startTime,
          this.endTime,
          unit.town,
        );
        this.cont = res.cont;
        this.imgUrl = res.img_base64;
        this.tableData = res.list;
      } catch (error) {
        this.$message.error("当前时次无数据");
      }
      this.loading = false;
    },
    changeControl(name) {
      this.currentControl = name;

      // 定义时间间隔映射

      if (this.timeIntervals[name]) {
        this.dateEnable = false;
        this.hourEnable = false;
        this.minuteEnable = false;
        // 处理固定时间间隔的情况
        const hours = this.timeIntervals[name];
        console.log("this.endTime", this.endTime);

        const startTime = this.$moment(this.endTime).subtract(hours, "hours");
        this.setDateTimePicker(this.$refs.pickerStime, startTime);
        this.startTime = startTime.format("YYYY-MM-DD HH:mm");
      } else if (name === "自定义") {
        // 处理自定义时间的情况
        this.dateEnable = false;
        this.hourEnable = false;
        this.minuteEnable = false;
      }

      // 设置结束时间为起始时间的时段间隔
      this.setDateTimePicker(
        this.$refs.pickerEtime,
        this.$moment(this.endTime),
      );
    },

    // 设置日期时间选择器的值
    setDateTimePicker(pickerRef, momentTime) {
      pickerRef.date = momentTime.format("YYYY-MM-DD");
      pickerRef.hour = momentTime.format("HH");
      pickerRef.minute = momentTime.format("mm");
    },
    callbackStart(time) {
      this.startTime = this.$moment(time).format("YYYY-MM-DD HH:mm");
      if (this.timeIntervals[this.currentControl]) {
        // 处理固定时间间隔的情况
        const hours = this.timeIntervals[this.currentControl];
        const changeTime = this.$moment(time).add(hours, "hour");
        this.setDateTimePicker(this.$refs.pickerEtime, changeTime);
        this.endTime = this.$moment(changeTime).format("YYYY-MM-DD HH:mm");
      }
    },
    callbackEnd(time) {
      this.endTime = this.$moment(time).format("YYYY-MM-DD HH:mm");
      if (this.timeIntervals[this.currentControl]) {
        // 处理固定时间间隔的情况
        const hours = this.timeIntervals[this.currentControl];
        const changeTime = this.$moment(time).subtract(hours, "hour");
        this.setDateTimePicker(this.$refs.pickerStime, changeTime);
        this.startTime = this.$moment(changeTime).format("YYYY-MM-DD HH:mm");
      }
    },
    hanldChange() {
      this.cont = "";
    },
  },
  mounted() {},
  components: {
    DatePicker,
  },
};
</script>

<style lang="less" scoped>
.main {
  flex: 1;
  position: relative;
  #map {
    width: 100%;
    height: 100%;
  }
  .panel {
    position: absolute;
    top: 1.8519vh;
    left: 1.04vw;
    width: 19.64vw;
    height: 88.7037vh;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 11px 18px 0px rgba(139, 157, 189, 0.35);
    border-radius: 6px;
    .title-img {
      width: 100%;
      height: 4.1333vh;
      object-fit: contain;
    }
    .content {
      padding: 1.1111vh 0.83vw;
      display: flex;
      flex-direction: column;
      gap: 1.1111vh;
      .content-item {
        display: flex;
        flex-direction: column;
        gap: 1.1111vh;
        .content-item-control {
          display: flex;
          justify-content: space-between;
          .control-item {
            cursor: pointer;
            width: 3.39vw;
            height: 3.5185vh;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #ffffff;
            box-shadow: 0px 4px 16px 0px rgba(192, 220, 244, 0.63);
            border-radius: 0.31vw;
            border: 1px solid #e1f0fb;
            font-size: 0.73vw;
            color: #333333;
          }
          .active {
            border: 1px solid #5696fa;
          }
        }
        .content-item-title {
          padding: 0 0.63vw;
          height: 3.4259vh;
          display: flex;
          align-items: center;
          background: #def0ff;
          border-radius: 0.21vw;
          font-weight: 600;
          font-size: 0.83vw;
          color: #333333;
        }
        .content-item-date {
          display: flex;
          align-items: center;
          gap: 0.52vw;
          .label {
            font-size: 0.73vw;
            color: #333333;
          }
        }

        /deep/.DatePicker {
          color: #0a0a0a;
          .picker-box-inner {
            background: rgba(247, 250, 255, 0.49);
            box-shadow: 0px 4px 8px 0px rgba(192, 220, 244, 0.43);
            border-radius: 4px;
            border: 1px solid #e3ebed;
            .date-picker {
              width: 6.03vw;
            }
            .select-box {
              width: 1.5vw;
            }
            .el-input__inner {
              color: #0a0a0a;
            }
            .el-input__prefix {
              color: #9b9c9f;
            }
            .icon-caret-top {
              border-bottom: 0.5em solid #9b9c9f;
            }
            .icon-caret-bottom {
              border-top: 0.5em solid #9b9c9f;
            }
          }
        }
        /deep/.el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
          gap: 1.8519vh 0;
          .el-checkbox {
            margin-right: 0;
            width: 50%;
          }
          .el-checkbox__inner {
            width: 0.83vw;
            height: 0.83vw;
            border-radius: 3px;
            border: 1px solid #c6cdcf;
          }
          .el-checkbox__label {
            font-size: 0.73vw;
            color: #333333;
          }
        }
      }
      .btn {
        margin: 1.8519vh 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .report-content {
    position: absolute;
    top: 1.8519vh;
    right: 4.98vw;
    width: 62.25vw;
    height: 88.7037vh;
    padding: 2.5vh 3.56vw;
    max-height: 83.4444vh;
    overflow: auto;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        font-weight: bold;
        font-size: 1.56vw;
        color: #333333;
        text-align: center;
      }
      .sub-title {
        font-weight: bold;
        font-size: 1.2vw;
        color: #333333;
        text-align: center;
      }
      .desc {
        margin: 3.8519vh 0;
        font-weight: 400;
        font-size: 1.03vw;
        color: #333333;
        line-height: 4.5926vh;
        text-indent: 2em;
      }
      .image {
        width: 37.06vw;
        height: 62.6667vh;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .table {
        padding: 3.8519vh 0;

        table {
          border: 1px solid #ccc;
          border-collapse: collapse;
          th,
          tr,
          td {
            text-align: center;
            padding: 0.78vw;
            border: 1px solid #ccc;
          }
          td {
            width: 10.42vw;
          }
          .xuhao {
            width: 2.6vw;
          }
        }
      }
    }
    .no-data {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
